<script setup lang="ts">
import { APP_HOME_PAGE } from '@/constants'

definePage({
  redirect: { name: APP_HOME_PAGE },
})
</script>
